export function initScroll(slider: HTMLDivElement) {
  const sliderWrapper = slider.querySelector(".slider-wrapper") as HTMLDivElement;
  const sliderItems = slider.querySelector(".slider .slider-items") as HTMLDivElement;
  const scrollLeft = slider.querySelector(".scroll-left") as HTMLDivElement;
  const scrollRight = slider.querySelector(".scroll-right") as HTMLDivElement;

  if (!scrollLeft || !scrollRight) {
    return;
  }

  const firstChild = slider.querySelector(".slider-items .slider-item:first-child");
  const lastChild = slider.querySelector(".slider-items .slider-item:last-child");

  if (!firstChild || !lastChild) {
    return;
  }

  if (!sliderWrapper || !sliderItems) {
    return;
  }

  scrollRight.addEventListener("click", () => {
    sliderWrapper.scrollLeft =
      sliderWrapper.scrollLeft + sliderItems.scrollWidth / sliderItems.children.length;
  });

  scrollLeft.addEventListener("click", () => {
    sliderWrapper.scrollLeft =
      sliderWrapper.scrollLeft - sliderItems.scrollWidth / sliderItems.children.length;
  });

  const options = {
    root: sliderWrapper, // relative to document viewport
    rootMargin: "0px", // Margin around root. Values are similar to CSS property. Unitless values aren't allowed
    threshold: 0.9, // visible amount of item shown in relation to root,
  };

  new IntersectionObserver((changes) => {
    manageScrollButtonVisibility(changes, scrollLeft);
  }, options).observe(firstChild);

  new IntersectionObserver((changes) => {
    manageScrollButtonVisibility(changes, scrollRight);
  }, options).observe(lastChild);
}

const manageScrollButtonVisibility = (
  changes: IntersectionObserverEntry[],
  element: HTMLDivElement,
) => {
  changes.forEach((change) => {
    if (change.intersectionRatio > 0.9) {
      element.classList.remove("fade-in");
      element.classList.add("fade-out");
    } else {
      element.classList.remove("fade-out");
      element.classList.add("fade-in");
    }
  });
};
